import React, { useEffect, useState } from 'react';

import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import clsx from 'clsx';

import { debounce, cloneDeep, isEmpty, unionBy } from 'lodash';

import queryString from 'query-string';

import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Popover from '@material-ui/core/Popover';
import Tooltip from '@material-ui/core/Tooltip';
import BobConfirmButton from './BobConfirmButton';

import SearchInput from '../containers/Global/SearchInput';

import { headerContent } from '../localization/en-us/headerContent';

import * as BobActions from '../actions/bobActions';
import * as DashboardActions from '../actions/dashboardActions';
import * as ConfigurationActions from '../actions/configurationActions';
import * as WeatherActions from '../actions/weatherActions';

import classes from './SensorSelect.module.css';

const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

const ScoreSensorSelect = ({
    activeConfiguration,
    activeNavSite,
    axes,
    activeNavEquipment,
    clearEntityScoresData,
    clearEntitySensorData,
    configuration,
    dashboardEndTimeStamp,
    dashboardIsCurrentTimeStamp,
    dashboardStartTimeStamp,
    desiredInterval,
    fetchEntitySensorData,
    fetchFaultOverlay,
    fetchScoringData,
    fetchSensorIds,
    fetchWeatherSensorData,
    handleChangeTabView,
    handleChangeView,
    history,
    meta,
    parentId,
    removeEntitySensorData,
    ruleScoreKpis,
    ruleScoringConfig,
    search,
    setActiveConfiguration,
    selectedRule,
    selectedRuleSensors,
    selectedSensors,
    selectedWeatherSensors,
    sensors,
    setEntityScoringData,
    setRuleScoringConfiguration,
    setSelectedRule,
    setSelectedRuleSensors,
    setSelectedSensors,
    setSelectedWeatherSensors,
    setConfiguration,
    siteId,
    view,
    ...props
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [searchValue, setSearchValue] = useState('');
    const [calculatedSensorSearchValue, setCalculatedSearchValue] = useState('');
    const [ruleSearchValue, setRuleSearchValue] = useState('');
    const [sensorMenuOpen, setSensorMenuOpen] = useState(false);
    const [ruleMenuOpen, setRuleMenuOpen] = useState(false);
    const [activeSensors, setActiveSensors] = useState([]);
    const [activeRule, setActiveRule] = useState({});
    const [activeWeatherSensors, setActiveWeatherSensors] = useState([]);
    const [activeExternalSensors, setActiveExternalSensors] = useState([]);
    const [externalSensors, setExternalSensors] = useState([]);
    const [externalSensorsList, setExternalSensorsList] = useState([]);
    const [externalSearchValue, setExternalSearchValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [rules, setRules] = useState([]);
    const [ruleSensors, setRuleSensors] = useState([]);
    const [calculatedSensors, setCalculatedSensors] = useState([]);
    const [calculatedSensorMenuOpen, setCalculatedSensorMenuOpen] = useState(false);
    const [externalSensorMenuOpen, setExternalSensorMenuOpen] = useState(false);
    const [weatherSensorMenuOpen, setWeatherSensorMenuOpen] = useState(false);
    const [hasCalculatedSensors,setHasCalculatedSensors] = useState(false);
    
    useEffect(() => {
        const { viewData } = activeConfiguration;

        if (!isEmpty(viewData)) {
            const {selectedRule, selectedSensors} = viewData;
            if (!isEmpty(selectedRule) || !isEmpty(selectedSensors)) {
                //May need to consider this line just to ensure score grid configuration
                //is not running on sensor grid and vice versa.
                if ((view === 'scoregrid' && viewData.viewType.includes('Score')) ||
                    (view === 'scoregraph' && viewData.viewType.includes('Score')) ||
                    (view === 'sensorgrid' && viewData.viewType.includes('Sensor')) ||
                    (view === 'sensorgraph' && viewData.viewType.includes('Sensor')) ||
                    (view === 'sensorgraph' && viewData.viewType.includes('Configuration')) ||
                    (view === 'sensorgrid' && viewData.viewType.includes('Configuration'))) {

                    setSelectedRuleSensors(viewData.selectedSensors);
                    setSelectedSensors(viewData.selectedSensors);
                    setSelectedWeatherSensors(viewData.selectedWeatherSensors ? viewData.selectedWeatherSensors : []);

                    applySavedConfiguration(selectedRule, selectedSensors, viewData.selectedWeatherSensors);
                }
            }
        }
    }, [activeConfiguration.viewData]);
    
    useEffect(() => {
        setActiveSensors(selectedRuleSensors);
    }, [selectedRuleSensors]);

    useEffect(() => {
        const init = async () => {
            setActiveSensors([]);

            let extSensors = [];
            let entityId;
            let ids = [];

            if (activeNavEquipment.id) {
                entityId =  activeNavEquipment.id;
            } else {
                entityId = queryValues.system;
            }
            if (selectedRule.ruleId) {
                ids = await fetchSensorIds(queryValues.site, entityId, [selectedRule.ruleId]);
            }
            
            selectedRule.sensorIds?.forEach(item => {
                if (!sensors.find(sensor => sensor.id === item.id)) {
                    item.externalSensor = true;
                    extSensors.push(item);
                }
            });

            setExternalSensors(extSensors);
            setExternalSensorsList(extSensors);

            //only hide if from the score grid view
            if (view === 'scoregrid' || view === 'scoregraph') {
                setSelectedRuleSensors([]);
                setActiveExternalSensors([]);
            }
            else {
                let combinedSensors = unionBy(selectedRule.sensorIds, ids, 'id');
                combinedSensors = unionBy(combinedSensors, selectedSensors, 'id');
                setSelectedRuleSensors(combinedSensors);
                setActiveSensors(combinedSensors ? combinedSensors : []);
                setActiveExternalSensors(extSensors);
            }
            setActiveRule(selectedRule);
        };

        if (!isEmpty(selectedRule)) init();
    }, [selectedRule]);

    useEffect(() => {
        setActiveWeatherSensors(selectedWeatherSensors);
    }, [selectedWeatherSensors]);

    useEffect(() => {
        setRules(ruleScoreKpis);
    }, [ruleScoreKpis]);

    useEffect(() => {
        setRuleSensors(sensors.filter(s => s.calculatedSensor === false));
        const calculatedSensorList = sensors.filter(s => s.calculatedSensor === true);
        setCalculatedSensors(calculatedSensorList);
        setHasCalculatedSensors(!isEmpty(calculatedSensorList));
    }, [sensors]);

    useEffect(() => {
        let extSensors = [];
        if (!isEmpty(activeSensors)) {
            activeSensors.forEach((item, index) => {

                if (!item.calculatedSensor) {
                    const sensor = sensors.find(s => s.id === item.id);

                    if (sensor) {
                        item.calculatedSensor = sensor.calculatedSensor || false;
                        item.rawUnitId = item.rawUnitId === undefined ? sensor.rawUnitId : item.rawUnitId;
                        item.presentationUnitId = item.presentationUnitId === undefined ? sensor.presentationUnitId : item.presentationUnitId;
                    } else {
                        item.calculatedSensor = false;
                    }

                    if (!sensors.find(sensor => sensor.id === item.id)) {
                        item.externalSensor = true;
                        extSensors.push(item);
                    }
                }
            });
        }
        setActiveExternalSensors(extSensors);

    }, [activeSensors]);

    const queryValues = queryString.parse(history.location.search);

    const open = Boolean(anchorEl);
    const id = open ? 'nav-select-popover' : undefined;

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSearch = searchFilter => {
        setSearchValue(searchFilter);
        const filteredSensors = sensors.filter(sensor => sensor.name.toLowerCase().includes(searchFilter.toLowerCase()));

        setRuleSensors(filteredSensors);
    };

    const handleCalculatedSensorFilter = searchFilter => {
        setCalculatedSearchValue(searchFilter);
        const filteredSensors = sensors.filter(sensor => sensor.calculatedSensor === true && sensor.name.toLowerCase().includes(searchFilter.toLowerCase()));

        setCalculatedSensors(filteredSensors);
    };

    const handleExternalSensorFilter = searchFilter => {
        setExternalSearchValue(searchFilter);
        const filteredSensors = externalSensors.filter(sensor => sensor.name.toLowerCase().includes(searchFilter.toLowerCase()));

        setExternalSensorsList(filteredSensors);
    };

    const handleRuleSearch = searchFilter => {
        setRuleSearchValue(searchFilter);

        const filteredRules = ruleScoreKpis.filter(rule => rule.ruleName.toLowerCase().includes(searchFilter.toLowerCase()));

        setRules(filteredRules);
    };

    const handleCheckbox = async (item, index) => {
        let updatedSensors = [...activeSensors];
        if (activeSensors.find(sensor => sensor.id === item.id)) {
            updatedSensors = updatedSensors.filter(sensor => sensor.id !== item.id);

            setActiveSensors(updatedSensors);
        } else {
            if (activeSensors.length >= 10) return;
            let newSensors = [];
            newSensors.push(item);
            updatedSensors = [...updatedSensors, ...newSensors];

            setActiveSensors(updatedSensors);
        }
    };

    const handleRuleCheckbox = async (item, index) => {
        if (activeRule.ruleId === item.ruleId) {
            setActiveRule({});
            setActiveSensors([]);
        } else {
            setActiveExternalSensors([]);
            setActiveRule(item);
            const rule = [item.ruleId];

            let entityId;

            if (activeNavEquipment.id) {
                entityId =  activeNavEquipment.id;
            } else {
                entityId = queryValues.system;
            }

            const ids = await fetchSensorIds(queryValues.site, entityId, rule);
            const activeIds = ids.filter(s => s.id !== EMPTY_GUID);
            setActiveSensors(activeIds);
            setSelectedRule({ ...item, sensorIds: activeIds });
        }
    };

    const handleWeatherCheckbox = async item => {
        let updatedWeatherSensors = [...activeWeatherSensors];

        if (activeWeatherSensors.find(sensor => sensor === item)) {
            updatedWeatherSensors = updatedWeatherSensors.filter(sensor => sensor !== item);

            setActiveWeatherSensors(updatedWeatherSensors);
        } else {
            let newSensors = [];
            newSensors.push(item);
            updatedWeatherSensors = [...updatedWeatherSensors, ...newSensors];
            setActiveWeatherSensors(updatedWeatherSensors);
        }
    };

    const handleExternalCheckbox = async item => {
        let updatedExternalSensors = [...activeExternalSensors];
        let updatedSensors = [...activeSensors];

        if (activeSensors.find(sensor => sensor.id === item.id)) {
            updatedExternalSensors = updatedExternalSensors.filter(sensor => sensor.id !== item.id);
            updatedSensors = updatedSensors.filter(sensor => sensor.id !== item.id);

            setActiveExternalSensors(updatedExternalSensors);
            setActiveSensors([...updatedSensors]);
        } else {
            let newSensors = [];
            newSensors.push(item);
            updatedExternalSensors = [...updatedExternalSensors, ...newSensors];

            setActiveExternalSensors(updatedExternalSensors);
            setActiveSensors([...updatedSensors, ...newSensors]);
        }
    };

    const applySavedConfiguration = async (savedRule, savedSensors, savedWeatherSensors) => {
        setLoading(true);
        setAnchorEl(null);

        let entity;
        let entityId;

        if (activeNavEquipment.id) {
            entity = { EquipmentId: activeNavEquipment.id };
            entityId = activeNavEquipment.id;
        } else {
            entity = { SystemId: queryValues.system };
            entityId = queryValues.system;
        }

        let weatherSensors = '';
        if (!isEmpty(savedWeatherSensors)) {
            weatherSensors = activeNavSite.address.postalCode + ':' + savedWeatherSensors.join(':');
        }

        let currentConfig = ruleScoringConfig;
        let promises = [];

        if (!isEmpty(savedRule)) {
            const rules = [savedRule.ruleId];

            // This block of code manages the rule config storage
            // We look to see if we have a current configuration
            if (!isEmpty(currentConfig.current)) {

                // If we have a current config we check to see if the current config is the rule selected
                if (ruleScoringConfig.current.ruleId === rules[0]) {

                    // If so we just fetch the scoring data from the current configuration
                    const sensorIds = ruleScoringConfig.current.ruleSensorIds;

                    currentConfig.current = {
                        ruleId:           rules[0],
                        sensorIds:        savedSensors,
                        ruleSensorIds:    sensorIds,
                        weatherSensorIds: savedWeatherSensors
                    };

                    setRuleScoringConfiguration(currentConfig);
                    promises.push(fetchScoringData(queryValues.company, savedSensors, rules, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { ...entity, weatherSensors  }));

                    // We check if the rule selected is one of the previous configurations
                } else if (ruleScoringConfig.previous.find(config => config.ruleId === rules[0])) {

                    // If so, we use the sensors from that configuration, set it as the new current, and remove it from the previous array.
                    const existingRule = currentConfig.previous.find(config => config.ruleId === rules[0]);
                    const currentRule = currentConfig.current;

                    currentConfig.previous.push(currentRule);
                    currentConfig.previous = currentConfig.previous.filter(item => item.ruleId !== rules[0]);

                    currentConfig.current = {
                        ruleId:           rules[0],
                        sensorIds:        savedSensors,
                        ruleSensorIds:    existingRule.ruleSensorIds,
                        weatherSensorIds: savedWeatherSensors
                    };

                    setRuleScoringConfiguration(currentConfig);

                    promises.push(fetchScoringData(queryValues.company, savedSensors, rules, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { ...entity, weatherSensors  }));

                    // This scenario is what happens when we have a current configuration but select a new rule.
                } else {
                    const ids = await fetchSensorIds(queryValues.site, entityId, rules);

                    const currentRule = currentConfig.current;
                    currentConfig.previous.push(currentRule);


                    currentConfig.current = {
                        ruleId:           rules[0],
                        sensorIds:        savedSensors,
                        ruleSensorIds:    ids,
                        weatherSensorIds: savedWeatherSensors
                    };

                    setRuleScoringConfiguration(currentConfig);

                    promises.push(fetchScoringData(queryValues.company, savedSensors, rules, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { ...entity, weatherSensors  }));
                }

                // This scenario is what happens when there has been no current configuration, initial load.
            } else {
                const ids = await fetchSensorIds(queryValues.site, entityId, rules);

                currentConfig.current = {
                    ruleId:           rules[0],
                    sensorIds:        savedSensors,
                    ruleSensorIds:    ids,
                    weatherSensorIds: savedWeatherSensors
                };

                promises.push(fetchScoringData(queryValues.company, savedSensors, rules, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { ...entity, weatherSensors  }));
            }
        } else {
            setEntityScoringData([]);
        }
        if (!isEmpty(savedSensors)) {
            let weatherSensors = '';
            if (!isEmpty(savedWeatherSensors)) {
                weatherSensors = activeNavSite.address.postalCode + ':' + savedWeatherSensors.join(':');
            }
            promises.push(fetchEntitySensorData(savedSensors, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { axes, entityId, weatherSensors }));
        } else {
            clearEntitySensorData();
        }

        await Promise.all(promises.map(p => p.catch(err => err)));

        setLoading(false);
    };

    const handleGo = async () => {
        setLoading(true);
        setAnchorEl(null);

        // configuration changes
        // setActiveConfiguration({});

        let updateConfiguration = cloneDeep(configuration);
        updateConfiguration.selectedRule = activeRule;
        updateConfiguration.selectedSensors = activeSensors;
        updateConfiguration.selectedWeatherSensors = activeWeatherSensors;
        setConfiguration(updateConfiguration);
    
        setSelectedRuleSensors(activeSensors);
        setSelectedSensors(activeSensors);
        setSelectedRule(activeRule);
        if (!isEmpty(activeWeatherSensors)) {
            setSelectedWeatherSensors(activeWeatherSensors);
        }
        else {
            setSelectedWeatherSensors([]);
        }
        
        let entity;
        let entityId;

        if (activeNavEquipment.id) {
            entity = { EquipmentId: activeNavEquipment.id };
            entityId = activeNavEquipment.id;
        } else {
            entity = { SystemId: queryValues.system };
            entityId = queryValues.system;
        }

        const rules = [activeRule.ruleId];

        let weatherSensors = '';
        if (!isEmpty(activeWeatherSensors)) {
            weatherSensors = activeNavSite.address.postalCode + ':' + activeWeatherSensors.join(':');
        }

        let currentConfig = ruleScoringConfig;
        let promises = [];

        if (!isEmpty(activeRule)) {
            if (!dashboardIsCurrentTimeStamp) {
                //Fetch Fault Overlay data if date picker is not current
                promises.push(fetchFaultOverlay(queryValues.company, entityId, activeRule.ruleId, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format()));
            }

            // This block of code manages the rule config storage
            // We look to see if we have a current configuration
            if (!isEmpty(currentConfig.current)) {

                // If we have a current config we check to see if the current config is the rule selected
                if (ruleScoringConfig.current.ruleId === rules[0]) {

                    // If so we just fetch the scoring data from the current configuration
                    const sensorIds = ruleScoringConfig.current.ruleSensorIds;

                    currentConfig.current = {
                        ruleId:        rules[0],
                        sensorIds:     activeSensors,
                        ruleSensorIds: sensorIds
                    };

                    setRuleScoringConfiguration(currentConfig);
                    promises.push(fetchScoringData(queryValues.company, activeSensors, rules, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { ...entity, weatherSensors }));

                    // We check if the rule selected is one of the previous configurations
                } else if (ruleScoringConfig.previous.find(config => config.ruleId === rules[0])) {

                    // If so, we use the sensors from that configuration, set it as the new current, and remove it from the previous array.
                    const existingRule = currentConfig.previous.find(config => config.ruleId === rules[0]);
                    const currentRule = currentConfig.current;

                    currentConfig.previous.push(currentRule);
                    currentConfig.previous = currentConfig.previous.filter(item => item.ruleId !== rules[0]);

                    currentConfig.current = {
                        ruleId:        rules[0],
                        sensorIds:     activeSensors,
                        ruleSensorIds: existingRule.ruleSensorIds
                    };

                    setRuleScoringConfiguration(currentConfig);

                    promises.push(fetchScoringData(queryValues.company, activeSensors, rules, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { ...entity, weatherSensors }));

                    // This scenario is what happens when we have a current configuration but select a new rule.
                } else {
                    const ids = await fetchSensorIds(queryValues.site, entityId, rules);

                    const currentRule = currentConfig.current;
                    currentConfig.previous.push(currentRule);


                    currentConfig.current = {
                        ruleId:        rules[0],
                        sensorIds:     activeSensors,
                        ruleSensorIds: ids
                    };

                    setRuleScoringConfiguration(currentConfig);

                    promises.push(fetchScoringData(queryValues.company, activeSensors, rules, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { ...entity, weatherSensors }));
                }

                // This scenario is what happens when there has been no current configuration, initial load.
            } else {
                const ids = await fetchSensorIds(queryValues.site, entityId, rules);

                currentConfig.current = {
                    ruleId:        rules[0],
                    sensorIds:     activeSensors,
                    ruleSensorIds: ids
                };

                promises.push(fetchScoringData(queryValues.company, activeSensors, rules, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { ...entity, weatherSensors }));
            }
        } else {
            setEntityScoringData([]);
        }
        if (!isEmpty(activeSensors) || !isEmpty(activeWeatherSensors)) {
            promises.push(fetchEntitySensorData(activeSensors, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { axes, entityId, weatherSensors }));
        } else {
            clearEntitySensorData();
        }

        await Promise.all(promises.map(p => p.catch(err => err)));

        setLoading(false);
    };

    const isChecked = item => {
        if (activeSensors.find(sensor => sensor.id === item.id)) {
            return true;
        }
        return false;
    };

    const isRuleChecked = item => {
        if (item.ruleId === activeRule.ruleId) {
            return true;
        }
        return false;
    };

    const isWeatherChecked = item => {
        if (activeWeatherSensors.find(sensor => sensor === item)) {
            return true;
        }
        return false;
    };

    const isExternalChecked = item => {
        if (activeExternalSensors.find(sensor => sensor === item)) {
            return true;
        }
        return false;
    };

    const handleClear = () => {
        setActiveRule({});
        setActiveExternalSensors([]);
        setActiveSensors([]);
        setActiveWeatherSensors([]);
        setCalculatedSensors([]);
        setSelectedRuleSensors([]);
        setSelectedSensors([]);
        setSelectedRule({});
        setSelectedWeatherSensors([]);
        setEntityScoringData([]);
        clearEntitySensorData();
        setHasCalculatedSensors(false);
    };

    const handleExpandSensors = () => {
        setSensorMenuOpen(!sensorMenuOpen);
    };

    const handleExpandCalculatedSensors = () => {
        setCalculatedSensorMenuOpen(!calculatedSensorMenuOpen);
    };

    const handleExpandRules = () => {
        setRuleMenuOpen(!ruleMenuOpen);
    };

    const handleExpandExternalSensors = () => {
        setExternalSensorMenuOpen(!externalSensorMenuOpen);
    };

    const isSelected = item => {
        if (selectedSensors.find(sensor => sensor.id === item.id)) {
            return true;
        }
        return false;
    };

    const sortedSensors = sensors => {
        let updatedSensors = [];
        updatedSensors = sensors.sort((a, b) => Number(isSelected(b)) - Number(isSelected(a)));

        return updatedSensors;
    };

    const handleExpandWeatherSensors = () => {
        setWeatherSensorMenuOpen(!weatherSensorMenuOpen);
    };

    return (
        <div className={classes.SensorSelect}>
            <Button
                aria-describedby={id}
                onClick={handleClick}
                disabled={!sensors.length}
            >
                <Tooltip
                    classes={{ tooltip: classes.tooltip }}
                    title="sensor"
                    placement="bottom"
                >
                    <div className={classes.Selector}>
                        <p>Sensor - {selectedRuleSensors.length + selectedWeatherSensors.length} Selected</p>
                    </div>
                </Tooltip>
            </Button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical:   'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical:   'top',
                    horizontal: 'left',
                }}
            >
                <List className={classes.ScoreSensorList}>
                    <ListItem
                        key={0}
                        onClick={() => handleExpandRules()}
                        classes={{
                            root: classes.RuleListItem
                        }}
                    >
                        <i className={clsx(`fas fa-chevron-${ruleMenuOpen ? 'down' : 'up'}`, classes.icon)} aria-hidden="true" />
                        {
                            activeRule.ruleName ?
                                `Rules - ${activeRule.ruleName}`
                                :
                                'Rules'
                        }
                    </ListItem>
                    {
                        ruleMenuOpen ?
                            <div className={classes.List}>
                                <SearchInput
                                    className={classes.SearchInput}
                                    placeholder={`${headerContent.search}`}
                                    search={debounce(handleRuleSearch, 500)}
                                    value={ruleSearchValue}
                                    noRadius
                                />
                                <List className={classes.RuleList}>
                                    {rules.map((item, index) => (
                                        <ListItem
                                            key={index}
                                            onClick={() => handleRuleCheckbox(item, index)}
                                            classes={{
                                                root: classes.ListItem
                                            }}
                                        >
                                            <Checkbox
                                                checked={isRuleChecked(item)}
                                            />
                                            {item.ruleName}
                                        </ListItem>
                                    ))}
                                </List>
                            </div>
                            :
                            null
                    }
                </List>
                <List className={classes.ScoreSensorList}>
                    <ListItem
                        key={0}
                        onClick={() => handleExpandSensors()}
                        classes={{
                            root: classes.RuleListItem
                        }}
                    >
                        <i className={clsx(`fas fa-chevron-${sensorMenuOpen ? 'down' : 'up'}`, classes.icon)} aria-hidden="true" />
                        {
                            activeSensors?.filter(s => s.calculatedSensor === false).length ?
                                `Sensors - ${activeSensors.filter(s => !s.calculatedSensor && !s.externalSensor).length} Selected`
                                :
                                'Sensors'
                        }
                    </ListItem>
                    {
                        sensorMenuOpen ?
                            <div className={classes.List}>
                                <SearchInput
                                    className={classes.SearchInput}
                                    placeholder={`${headerContent.search}`}
                                    search={debounce(handleSearch, 500)}
                                    value={searchValue}
                                    noRadius
                                />
                                <List className={classes.RuleList}>
                                    {sortedSensors(ruleSensors).map((item, index) => (
                                        <ListItem
                                            key={index}
                                            onClick={() => handleCheckbox(item, index)}
                                            classes={{
                                                root: classes.ListItem
                                            }}
                                        >
                                            <Checkbox
                                                checked={isChecked(item)}
                                            />
                                            {item.name}
                                        </ListItem>
                                    ))}
                                </List>
                            </div>
                            :
                            null
                    }
                </List>
                { hasCalculatedSensors ? 
                    <List className={classes.ScoreSensorList}>
                        <ListItem
                            key={0}
                            onClick={() => handleExpandCalculatedSensors()}
                            classes={{
                                root: classes.RuleListItem
                            }}
                        >
                            <i className={clsx(`fas fa-chevron-${calculatedSensorMenuOpen ? 'down' : 'up'}`, classes.icon)} aria-hidden="true" />
                            {
                                activeSensors?.filter(s => s.calculatedSensor === true).length ?
                                    `Calculated Sensors - ${activeSensors.filter(s => s.calculatedSensor === true).length} Selected`
                                    :
                                    'Calculated Sensors'
                            }
                        </ListItem>
                        {
                            calculatedSensorMenuOpen ?
                                <div className={classes.List}>
                                    <SearchInput
                                        className={classes.SearchInput}
                                        placeholder={`${headerContent.search}`}
                                        search={debounce(handleCalculatedSensorFilter, 500)}
                                        value={calculatedSensorSearchValue}
                                        noRadius
                                    />
                                    <List className={classes.RuleList}>
                                        {sortedSensors(calculatedSensors).map((item, index) => (
                                            <ListItem
                                                key={index}
                                                onClick={() => handleCheckbox(item, index)}
                                                classes={{
                                                    root: classes.ListItem
                                                }}
                                            >
                                                <Checkbox
                                                    checked={isChecked(item)}
                                                />
                                                {item.name}
                                            </ListItem>
                                        ))}
                                    </List>
                                </div>
                                :
                                null
                        }
                    </List>
                    : null
                }
                {
                    !isEmpty(externalSensors) ?
                        <List className={classes.ScoreSensorList}>
                            <ListItem
                                key={0}
                                onClick={() => handleExpandExternalSensors()}
                                classes={{
                                    root: classes.RuleListItem
                                }}
                            >
                                <i className={clsx(`fas fa-chevron-${externalSensorMenuOpen ? 'down' : 'up'}`, classes.icon)} aria-hidden="true" />
                                {
                                    activeExternalSensors.length ?
                                        `External Sensors - ${activeExternalSensors.length} Selected`
                                        :
                                        'External Sensors'
                                }
                            </ListItem>
                            {
                                externalSensorMenuOpen ?
                                    <div className={classes.List}>
                                        <SearchInput
                                            className={classes.SearchInput}
                                            placeholder={`${headerContent.search}`}
                                            search={debounce(handleExternalSensorFilter, 500)}
                                            value={externalSearchValue}
                                            noRadius
                                        />
                                        <List className={classes.RuleList}>
                                            {sortedSensors(externalSensorsList).map((item, index) => (
                                                <ListItem
                                                    key={index}
                                                    onClick={() => handleExternalCheckbox(item)}
                                                    classes={{
                                                        root: classes.ListItem
                                                    }}
                                                >
                                                    <Checkbox
                                                        checked={isExternalChecked(item)}
                                                    />
                                                    {item.name}
                                                </ListItem>
                                            ))}
                                        </List>
                                    </div>
                                    :
                                    null
                            }
                        </List>
                        : null
                }
                <List className={classes.ScoreSensorList}>
                    <ListItem
                        key={0}
                        onClick={() => handleExpandWeatherSensors()}
                        classes={{
                            root: classes.RuleListItem
                        }}
                    >
                        <i className={clsx(`fas fa-chevron-${weatherSensorMenuOpen ? 'down' : 'up'}`, classes.icon)} aria-hidden="true" />
                        {
                            activeWeatherSensors.length ?
                                `Weather Sensors - ${activeWeatherSensors.length} Selected`
                                :
                                'Weather Sensors'
                        }
                    </ListItem>
                    {
                        weatherSensorMenuOpen ?
                            <div className={classes.List}>
                                <List className={classes.RuleList}>
                                    <ListItem
                                        key={0}
                                        onClick={() => handleWeatherCheckbox('temperature')}
                                        classes={{
                                            root: classes.ListItem
                                        }}
                                    >
                                        <Checkbox
                                            checked={isWeatherChecked('temperature')}
                                        />
                                        Temperature
                                    </ListItem>
                                    <ListItem
                                        key={1}
                                        onClick={() => handleWeatherCheckbox('humidity')}
                                        classes={{
                                            root: classes.ListItem
                                        }}
                                    >
                                        <Checkbox
                                            checked={isWeatherChecked('humidity')}
                                        />
                                        Humidity
                                    </ListItem>
                                    <ListItem
                                        key={2}
                                        onClick={() => handleWeatherCheckbox('pressure')}
                                        classes={{
                                            root: classes.ListItem
                                        }}
                                    >
                                        <Checkbox
                                            checked={isWeatherChecked('pressure')}
                                        />
                                        Pressure
                                    </ListItem>
                                    <ListItem
                                        key={3}
                                        onClick={() => handleWeatherCheckbox('minTemperature')}
                                        classes={{
                                            root: classes.ListItem
                                        }}
                                    >
                                        <Checkbox
                                            checked={isWeatherChecked('minTemperature')}
                                        />
                                        Min Temperature
                                    </ListItem>
                                    <ListItem
                                        key={4}
                                        onClick={() => handleWeatherCheckbox('maxTemperature')}
                                        classes={{
                                            root: classes.ListItem
                                        }}
                                    >
                                        <Checkbox
                                            checked={isWeatherChecked('maxTemperature')}
                                        />
                                        Max Temperature
                                    </ListItem>
                                </List>
                            </div>
                            :
                            null
                    }
                </List>
                {
                    view === 'scoregrid' || view === 'scoregraph' ?
                        <div className={isEmpty(activeRule) ? classes.HelperTextError : classes.HelperText}>
                            <i className={clsx('fas fa-info-circle', classes.HelpIcon)} />
                            You must select a rule
                        </div>
                        :
                        null
                }
                <div className={activeSensors?.length >= 10 ? classes.HelperTextError : classes.HelperText}>
                    <i className={clsx('fas fa-info-circle', classes.HelpIcon)} />
                    You can only select up to 10 sensors
                </div>
                <div className={classes.ScoreButtonContainer}>
                    <BobConfirmButton
                        label={'Go'}
                        className={loading || (isEmpty(activeRule) && isEmpty(activeSensors) && isEmpty(activeWeatherSensors)) ? classes.DisabledGoButton : null}
                        onClick={() => handleGo()}
                        disabled={loading || (view === 'scoregrid' || view === 'scoregraph' ? isEmpty(activeRule) : isEmpty(activeSensors) && isEmpty(activeWeatherSensors))}
                    />
                    <BobConfirmButton
                        label={'Clear'}
                        className={loading ? classes.DisabledClearButton : classes.Buttons}
                        onClick={handleClear}
                        disabled={loading}
                    />
                    {
                        process.env.sensorConfigurationEnabled ?
                            (view === 'sensorgrid' || view === 'sensorgraph') ?
                                <BobConfirmButton
                                    className={classes.Buttons}
                                    label={'Configure'}
                                    onClick={() => handleChangeTabView()}
                                    disabled={loading}
                                />
                                :
                                null
                            :
                            null
                    }
                </div>
            </Popover>
        </div>
    );
};

ScoreSensorSelect.defaultProps = {
    configuration: {}
};

const mapStateToProps = state => {
    return {
        activeNavSite:               state.bob.activeNavSite,
        dashboardEndTimeStamp:       state.dashboard.dashboardEndTimeStamp,
        dashboardIsCurrentTimeStamp: state.dashboard.dashboardIsCurrentTimeStamp,
        dashboardStartTimeStamp:     state.dashboard.dashboardStartTimeStamp,
        desiredInterval:             state.dashboard.desiredInterval,
        selectedRule:                state.dashboard.selectedRule,
        selectedRuleSensors:         state.dashboard.selectedRuleSensors,
        selectedSensors:             state.dashboard.selectedSensors,
        selectedWeatherSensors:      state.dashboard.selectedWeatherSensors,
        activeNavEquipment:          state.bob.activeNavEquipment,
        ruleScoreKpis:               state.dashboard.ruleScoreKpis,
        ruleScoringConfig:           state.dashboard.ruleScoringConfig
    };
};

const mapDispatchToProps = {
    ...BobActions,
    ...ConfigurationActions,
    ...DashboardActions,
    ...WeatherActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ScoreSensorSelect));
